module.exports = __webpack_public_path__ + "img/4_hills.9996fa7c.jpg";